module.exports = __webpack_public_path__ + "static/media/400012_01.a0e0b818.png";